import React from 'react';

interface LiveCampaignBannerProps {
  show?: boolean;
}

const LiveCampaignBanner: React.FC<LiveCampaignBannerProps> = ({
  show = true,
}) => {
  if (!show) return null;

  return (
    <div className="bg-warning-background rounded-lg border border-warning/30 px-4 py-3 flex items-center gap-3">
      <div className="relative flex items-center justify-center flex-shrink-0">
        <div className="absolute w-3 h-3 bg-warning rounded-full animate-pulse opacity-75" />
        <div className="relative w-3 h-3 bg-warning rounded-full" />
      </div>
      <div className="text-sm font-medium text-warning-foreground">
        After any changes, you need to save the campaign to make it live.
      </div>
    </div>
  );
};

export default LiveCampaignBanner;
